if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slider = null;
        this.sliderList = null;
        this.slides = [];
        this.currentSlideIndex = 0;
      }

      connectedCallback() {
        super.connectedCallback();
        this.slider = this.querySelector('slider-component');
        if (this.slider) {
          this.sliderList = this.slider.querySelector('[id^="Slider-Modal-"]');
          this.slides = Array.from(this.sliderList.querySelectorAll('.product-media-modal__slide'));
          this.setupSliderNavigation();
        }
      }

      setupSliderNavigation() {
        if (!this.slider || !this.sliderList) return;

        // Update slider counter when slide changes
        this.sliderList.addEventListener('scroll', () => {
          this.updateSliderCounter();
        });

        // Handle prev/next button clicks
        const prevButton = this.querySelector('button[name="previous"]');
        const nextButton = this.querySelector('button[name="next"]');
        
        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.goToPreviousSlide();
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.goToNextSlide();
          });
        }

        // Handle keyboard navigation
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.goToPreviousSlide();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.goToNextSlide();
          }
        });
      }

      updateSliderCounter() {
        if (!this.sliderList || this.slides.length === 0) return;

        const scrollLeft = this.sliderList.scrollLeft;
        const slideWidth = this.sliderList.clientWidth;
        const currentIndex = Math.round(scrollLeft / slideWidth);

        if (currentIndex !== this.currentSlideIndex && currentIndex < this.slides.length) {
          this.currentSlideIndex = currentIndex;
          this.slides.forEach((slide, index) => {
            slide.classList.toggle('is-active', index === currentIndex);
          });

          const currentCounter = this.querySelector('.slider-counter--current');
          if (currentCounter) {
            currentCounter.textContent = currentIndex + 1;
          }
        }
      }

      goToSlide(index) {
        if (!this.sliderList || index < 0 || index >= this.slides.length) return;

        const slide = this.slides[index];
        if (slide) {
          this.sliderList.scrollTo({
            left: slide.offsetLeft,
            behavior: 'smooth'
          });
          this.currentSlideIndex = index;
        }
      }

      goToNextSlide() {
        const nextIndex = (this.currentSlideIndex + 1) % this.slides.length;
        this.goToSlide(nextIndex);
      }

      goToPreviousSlide() {
        const prevIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length;
        this.goToSlide(prevIndex);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        // Reinitialize slides in case they weren't set up yet
        if (!this.slides || this.slides.length === 0) {
          this.slider = this.querySelector('slider-component');
          if (this.slider) {
            this.sliderList = this.slider.querySelector('[id^="Slider-Modal-"]');
            this.slides = Array.from(this.sliderList.querySelectorAll('.product-media-modal__slide'));
            if (!this.sliderList.hasAttribute('data-navigation-setup')) {
              this.setupSliderNavigation();
              this.sliderList.setAttribute('data-navigation-setup', 'true');
            }
          }
        }

        // Find the slide with matching data-media-id
        const activeSlide = this.slides.find(slide => {
          const slideMediaId = slide.getAttribute('data-media-id');
          return slideMediaId === mediaId;
        });
        
        if (activeSlide && this.sliderList) {
          // Update active classes
          this.slides.forEach((slide) => {
            slide.classList.remove('is-active');
          });
          activeSlide.classList.add('is-active');

          // Scroll to active slide
          this.currentSlideIndex = this.slides.indexOf(activeSlide);
          this.sliderList.scrollTo({
            left: activeSlide.offsetLeft,
            behavior: 'instant'
          });
          
          // Update counter
          const currentCounter = this.querySelector('.slider-counter--current');
          if (currentCounter) {
            currentCounter.textContent = this.currentSlideIndex + 1;
          }

          // Handle deferred media loading
          const deferredMedia = activeSlide.querySelector('deferred-media, product-model');
          if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
            deferredMedia.loadContent();
          }
        }
      }
    }
  );
}
